export default function ItemTitle({ title }: { title: string }) {
  return (
    <h1 className='mb-4 font-roboto-condensed text-4xl font-semibold'>
      {title}
    </h1>
  );
}
